import type { NotificationFormServicesData } from './notificationFormServicesData.d';
import React, { type JSX } from 'react';

import { NotificationFormServices } from '/react4xp/parts/notificationFormServices/NotificationFormServices';


export default function (props: { data: NotificationFormServicesData }): JSX.Element {
	return <NotificationFormServices {...props} />;
}
